import { IFinancialCockpitEltDocument } from '../../api/types'

export const canDownloadEltPptx = (
  document: Pick<IFinancialCockpitEltDocument, 'PPTXReport' | 'UID' | 'EntryId'>
): boolean => Boolean(document.PPTXReport && document.UID && document.EntryId)
